import { BaseModel } from "model/BaseModel";

export default class ItemPeriodicidade implements BaseModel {
    id: number;
    codigo: string | null;
    diaSemana: string | null;
    mes: string | null;
    diaMes: number | null;
    semanaMes: string | null;

    constructor(
        id: number, 
        codigo: string | null, 
        diaSemana: string | null,
        semanaMes: string | null,
        diaMes: number | null,
        mes: string | null
    ) {
        this.id = id;
        this.codigo = codigo;
        this.diaSemana = diaSemana;
        this.semanaMes = semanaMes;
        this.diaMes = diaMes;
        this.mes = mes;
    }
}